import React, { useState } from "react";
import { getBlogPostsBookmarksAPI } from "../../api/GetPosts";
import { useQuery } from "@tanstack/react-query";
import { useAuthStore } from "../../store/AuthStore";
import Loader from "../mini/Loader";
import Paginator from "../medium/Paginator";
import ArticleCard from "../medium/ArticleCard";
import sx from "./Dashboard.module.scss";

const Bookmarked = () => {
  const { userData } = useAuthStore();

  const [page, setPage] = useState(1);

  const { isLoading, data: myBookmarks } = useQuery({
    queryKey: ["GetBookmarks", page, userData],
    queryFn: () =>
      getBlogPostsBookmarksAPI({
        size: 10,
        page: page,
        userId: userData.id,
      }),
    select: ({ data }) => data.data,
  });

  const handlePagination = (currPage) => {
    setPage(currPage);
  };

  return (
    <div className={sx.root}>
      <div className={sx.body}>
        {isLoading ? (
          <Loader />
        ) : (
          myBookmarks &&
          (myBookmarks.bookmarks.length > 0 ? (
            <>
              {myBookmarks.bookmarks.map(({ post }) => (
                <ArticleCard
                  noRedirect={false}
                  post={post}
                  isBookmarkTab={true}
                />
              ))}

              {myBookmarks.count > 10 && (
                <Paginator
                  count={myBookmarks.count}
                  currentPage={page}
                  pageChange={handlePagination}
                />
              )}
            </>
          ) : (
            <div className={sx.noPosts}>
              <p>
                No Bookmarks yet, Search for Posts and then you can bookmark
                them.
              </p>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Bookmarked;
